import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { useLeadsOnDutySubscription$data } from "@/modules/leads-on-duty/services/__generated__/useLeadsOnDutySubscription.graphql"
import { useLeadsOnDutySubscription } from "@/modules/leads-on-duty/services/useLeadsOnDutySubscription"

interface LeadOnDutyAgent {
  id: string
  firstName: string
  lastName: string
}

const composeAgentDisplayNames = (agents: readonly LeadOnDutyAgent[]) =>
  agents.map((agent) => `${agent.firstName} ${agent.lastName}`).join(", ")

const LeadsOnDutyBanner = () => {
  const { t } = useTranslation()
  const [leadsOnDuty, setLeadsOnDuty] = useState<useLeadsOnDutySubscription$data | null | undefined>(null)

  useLeadsOnDutySubscription(setLeadsOnDuty)

  if (!leadsOnDuty) {
    return null
  }

  const { medicalSupervisors, operationsLeads } = leadsOnDuty.leadsOnDutyChanged

  const roleSegments: string[] = []
  if (medicalSupervisors.length > 0) {
    roleSegments.push(`${t("leadsOnDuty.medicalSupervisorLabel")}: ${composeAgentDisplayNames(medicalSupervisors)}`)
  }
  if (operationsLeads.length > 0) {
    roleSegments.push(`${t("leadsOnDuty.operationsLeadLabel")}: ${composeAgentDisplayNames(operationsLeads)}`)
  }

  if (roleSegments.length === 0) {
    return null
  }

  return (
    <Banner variant="info" data-testid="leads-on-duty-banner">
      {roleSegments.join(" // ")}
    </Banner>
  )
}

export { LeadsOnDutyBanner }
